import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e999462"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subtasks-list" }

import { PropType, ref, watch } from 'vue';
import { SubtaskModel } from '@/components/task-forms/models';
import { TaskSubtaskView } from '@/components/task-forms/components';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'subtasks-list',
  props: {
  /**id преокта */
  projectId: { type: Number, required: true },
  /**Список подзадач */
  subtasks: { type: Array as PropType<SubtaskModel[]> },
  /**id очереди */
  queueId: { type: String },
  editing: { type: Boolean, default: true },
},
  emits: ["remove", "updatedSubtask"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;


/**События */


/**Ссылка на подзадачи */
const $subtaskList = ref<InstanceType<typeof TaskSubtaskView>>();

__expose({
  subtask: $subtaskList,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.subtasks, (subtask) => {
      return (_openBlock(), _createBlock(_unref(TaskSubtaskView), {
        ref_for: true,
        ref_key: "$subtaskList",
        ref: $subtaskList,
        projectId: __props.projectId,
        subtask: subtask,
        key: subtask.Id,
        queueId: __props.queueId,
        editing: __props.editing,
        onOnClickDelete: ($event: any) => (emit('remove', subtask.Id)),
        onUpdatedSubtask: _cache[0] || (_cache[0] = ($event: any) => (emit('updatedSubtask', $event)))
      }, null, 8, ["projectId", "subtask", "queueId", "editing", "onOnClickDelete"]))
    }), 128))
  ]))
}
}

})